var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-observer',{ref:"validator",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit, invalid }){return [_c('form',{on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.submit)}}},[_vm._t("default",null,{"invalid":invalid})],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }